/**
 * Animal avatars for anyone without a camera on — served from our own
 * /public/avatars (384px, ~20KB each) so they appear instantly on a slow
 * connection. 100 animals.
 *
 * The animal is picked from the participant's name AND the class they are in,
 * so it is stable for the whole class (reloads, rejoins, the recorder all agree)
 * but re-shuffles for the next class. The class key also permutes the whole
 * pool, so the first person to join a class doesn't always land on the same
 * animal.
 */
const COUNT = 100;

const hash = (key) => {
  const s = String(key || "guest");
  let h = 2166136261;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
};

let scope = "";

/** Call once per class (room name) before any avatar is rendered. */
export function setAvatarScope(key) {
  scope = String(key || "");
}

export function avatarUrl(name) {
  const s = String(name || "guest").trim().toLowerCase();
  // Two independent hashes: one picks a slot, the other rotates the whole pool
  // per class, so the mapping is a different shuffle in every class.
  const slot = hash(`${scope}|${s}`) % COUNT;
  const rotate = hash(`rot|${scope}`) % COUNT;
  const n = ((slot + rotate) % COUNT) + 1;
  return `/avatars/a${String(n).padStart(3, "0")}.jpg`;
}

export const AVATAR_COUNT = COUNT;
